import { render, staticRenderFns } from "./EmptyLayout.vue?vue&type=template&id=d6c081fa&scoped=true"
import script from "./EmptyLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./EmptyLayout.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c081fa",
  null
  
)

export default component.exports